import {ListTable} from "../component/ListTable";
import {useContext, useEffect, useState} from "react";
import {Context} from "../component/context";
import {Get} from "component/const/Get";
import {filter} from "component/const/Functions";
import {getUserId} from "component/const/ForAuth";

export const TestResult = () =>{

        const {search} = useContext(Context);
        const [test, setTest] = useState(null)
        const [data, setData] = useState(null)
        useEffect(()=>{
                getUserId()
                    .then(data=>{Get(`list_test_result?user_id=eq.${data}&graded=eq.true`)
                        .then(res=>setTest(res))})
        },[])

        useEffect(() => {
                setData(filter(test, search))
        }, [test, search]);

        return <ListTable data={data}/>
}